import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";

const dropzoneStyle: any = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",   
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
    transition: "border 0.24s ease-in-out",
    cursor: "pointer",
    height: '229px',
    borderLeft:'1px solid #eeeeee',
    borderRight:'1px solid #eeeeee'
};

const activeDropzoneStyle: any = {
    borderColor: "#00adb5",
};

const DropzoneText: any = {
    margin: "0",
    fontSize: "16px",
    fontWeight: "600",
    textAlign: "center",
};

const ImagePreview: any = {
    display: "flex",
    maxWidth: "100%",
    maxHeight: "100%",
    margin: "auto",
    borderRadius: "2px",
};

const FileName: any = {
    display: "flex",
    fontSize: "14px",
    marginTop: "8px",
};

const DropzoneComponent = () => {
    const [files, setFiles] = useState([]);
    const onDrop = useCallback((acceptedFiles: any) => {
        setFiles(
            acceptedFiles.map((file: any) =>
                Object.assign(file, {
                    preview: URL.createObjectURL(file),
                })
            )
        );
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: {
            'image/png': ['.png'],
            'image/jpg': ['.jpg'],
            'image/jpeg': ['.jpeg'],
        },
        maxSize: 1024 * 1024 * 5,
        maxFiles: 1,
    });

    const fileList = files.map((file: any) => (
        <li key={file.name}>
            <img style={ImagePreview} src={file.preview} alt={file.name} />
            <span style={FileName}>{file.name}</span>
        </li>
    ));

    return (
        <>
            <div
                style={
                    isDragActive
                        ? { ...dropzoneStyle, ...activeDropzoneStyle }
                        : dropzoneStyle
                }
                {...getRootProps()}
            >
                <input {...getInputProps()} />
                <p
                    style={DropzoneText}
                >
                    Drag & drop file here
                    or browse file from device
                    JPEG, PNG and SVG
                    Dimension (Width: 212px, Height: 48px), Max Size: 5MB
                </p>

            </div>

            <div>
                <ul>{fileList}</ul>
            </div>
        </>

    );
};

export default DropzoneComponent;